import { useMemo } from 'react';

import { useGetGroupAdmins } from '@/features/api/hooks/grapevine-group/useGetGroupAdmins';
import { useAppState } from '@/features/authorization/provider/useAppState';
import { useRefetchOnFocus } from '@/shared/hooks/useRefetchOnFocus';
import { isEmptyOrNull } from '@/shared/utils/string';

// Todo: check if the hook is fine and reuse in other places

/**
 * Checks if passed user is an admin of the group
 * @param groupId group id
 * @param userId user id. Pass no id to check own user
 * @returns true if user is admin
 */
export const useIsGroupAdmin = (groupId: string, userId?: string) => {
  const adminsQuery = useGetGroupAdmins(groupId);
  const { data: admins } = adminsQuery;

  useRefetchOnFocus(adminsQuery);

  const adminIds = useMemo(
    () => new Set<string>(admins?.map((admin) => admin.id)),
    [admins]
  );
  const { userId: ownUserId } = useAppState();

  if (isEmptyOrNull(userId)) {
    return adminIds.has(ownUserId);
  }

  return adminIds.has(userId);
};
